import { fromJS } from 'immutable';

import _ from 'lodash';
import AccountsService from '../../utils/AccountsService';

import {
  loginRoutine,
  fetchUserRoutine,
  fetchAccountsRoutine,
  upgradeAccountRoutine,
  fetchTaskCountRoutine,
  fetchPaymentSourceRoutine,
  updatePaymentSourceRoutine,
  selectAccountRoutine,
  fetchInvoicesRoutine, addAccountRoutine, fetchAccountRoutine,
} from '../routines';

const initialState = fromJS({});

export default function (state = initialState, action) {
  switch (action.type) {
    case addAccountRoutine.SUCCESS:
      console.log('action',);
      return state.updateIn(['accounts','data'], (accounts) => accounts.push(fromJS(_.assign({ permissions: ['Administrator'] }, action.payload.response.data))));

    case fetchAccountsRoutine.TRIGGER:
      return state.setIn(['accounts', 'loading'], true);
    case fetchAccountsRoutine.SUCCESS:
      return state.set('accounts', fromJS(action.payload.response));
    case fetchAccountsRoutine.FAILURE:
      return state.setIn(['accounts', 'loading'], false);

    case fetchAccountRoutine.TRIGGER:
      return state.setIn(['account'], fromJS(AccountsService.getAccount()));

    case upgradeAccountRoutine.SUCCESS:
      const resp = action.payload.response;
      if (resp.data.settings) {
        const { settings } = resp.data;
        // const account = _.assign(getAccount(), { settings: _.assign(getAccount().settings, settings) });
        //
        // setAccount(account);
        return state.setIn(['account', 'settings'], fromJS(settings)).update('account', (account) => {
          AccountsService.setAccount(account.toJS());
          return account;
        });
      }

      return state;

    case loginRoutine.SUCCESS:
    case fetchUserRoutine.SUCCESS:
      return state.set('account', fromJS(AccountsService.getAccount()));

    case selectAccountRoutine.SUCCESS:
      AccountsService.setAccount(action.payload);
      return state.set('account', fromJS(action.payload));

    case fetchTaskCountRoutine.SUCCESS:
      console.log('action.payload.response', action.payload.response);
      return state.setIn(['account', 'taskCount'], action.payload.response.data);

    case fetchPaymentSourceRoutine.SUCCESS:
      return state.setIn(['account', 'paymentSource'], fromJS(action.payload.response.data));
    case updatePaymentSourceRoutine.SUCCESS:
      return state.setIn(['account', 'paymentSource'], fromJS(action.payload.response.data));

    case fetchInvoicesRoutine.TRIGGER:
      return state.set('loadingInvoices', true);
    case fetchInvoicesRoutine.SUCCESS:
      return state.set('invoices', fromJS(action.payload.response));
    case fetchInvoicesRoutine.FAILURE:
      console.log('FULFILL');
      return state;

    default :
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/accounts.js